export interface BackendAgentProgressiveOverlayBounds {
  height: number;
  left: number;
  top: number;
  width: number;
}

interface GetBackendAgentTargetBoundsByIdOptions {
  attribute: 'data-entry-id' | 'data-field-id';
  ids: readonly string[];
  layoutRoot: HTMLElement;
}

interface BackendAgentProgressiveOverlayEdges {
  bottom: number;
  left: number;
  right: number;
  top: number;
}

export function getBackendAgentTargetBoundsById({
  attribute,
  ids,
  layoutRoot
}: GetBackendAgentTargetBoundsByIdOptions): ReadonlyMap<
  string,
  BackendAgentProgressiveOverlayBounds
> {
  const candidateIdSet = new Set(ids);
  const edgesById = new Map<string, BackendAgentProgressiveOverlayEdges>();

  for (const element of layoutRoot.querySelectorAll<HTMLElement>(`[${attribute}]`)) {
    const id = element.getAttribute(attribute);
    if (!id || !candidateIdSet.has(id)) {
      continue;
    }

    const rect = element.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) {
      continue;
    }

    const existingEdges = edgesById.get(id);
    edgesById.set(
      id,
      existingEdges
        ? {
            bottom: Math.max(existingEdges.bottom, rect.bottom),
            left: Math.min(existingEdges.left, rect.left),
            right: Math.max(existingEdges.right, rect.right),
            top: Math.min(existingEdges.top, rect.top)
          }
        : { bottom: rect.bottom, left: rect.left, right: rect.right, top: rect.top }
    );
  }

  return new Map(
    [...edgesById].map(([id, { bottom, left, right, top }]) => [
      id,
      { height: bottom - top, left, top, width: right - left }
    ])
  );
}
